import { useEffect } from 'react';
import { APPLICATION_TITLE } from '@atlassian/temp-analytics';

export function useTitle(id: string, title?: string) {
  useEffect(() => {
    const prevTitle = document.title;
    let titleSegments = [id, title, APPLICATION_TITLE.ADVOCATE_CENTRAL];
    titleSegments = titleSegments.filter(Boolean);
    document.title = titleSegments.join(' | ');
    return () => {
      document.title = prevTitle;
    };
  }, [id, title]);
}

export function useDocTitle(id: string, title?: string, appTitle?: string, showOnlyAppTitle?: boolean) {
  /**
   * Update the document title of the web page.
   *
   * Use cases:
   * 1. Sets the document title without `title` param and defaults to PPC without `appTitle` param
   * useDocTitle(id); --> id + ' | ' + APPLICATION_TITLE.PPC
   *
   * 2. Sets the document title with `title` param and defaults to PPC without `appTitle` param
   * useDocTitle(id, title); --> id + ' | ' + title + ' | ' + APPLICATION_TITLE.PPC
   *
   * 3. Sets custom application title using `appTitle` param
   * useDocTitle(id, title, APPLICATION_TITLE.ADVOCATE_CENTRAL); --> id + ' | ' + title + ' | ' + APPLICATION_TITLE.ADVOCATE_CENTRAL
   */
  useEffect(() => {
    if (showOnlyAppTitle) {
      const prevTitle = document.title;
      document.title = appTitle || APPLICATION_TITLE.PPC;
      return () => {
        document.title = prevTitle;
      };
    }
    const prevTitle = document.title;
    const changedTitle = title ? id + ' | ' + title + ' | ' : id + ' | ';
    document.title = changedTitle + (appTitle || APPLICATION_TITLE.PPC);
    return () => {
      document.title = prevTitle;
    };
  });
}
